import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { Spin } from 'common/components';
import { numberToString } from 'common/helpers';
import { SocketContext } from 'common/context/socket/socket.context';
import { useAppSelector } from 'app/store/store.hooks';
import { selectAuth, selectXUserId } from 'entities/Auth/Auth.slice';

interface IComponentProps {
  children: ReactNode;
}

export const SocketProvider: React.FC<IComponentProps> = ({ children }) => {
  // auth
  const auth = useAppSelector(selectAuth);
  const xUserId = useAppSelector(selectXUserId);

  const socketRef = useRef<Socket | null>(null);
  const [connecting, setConnecting] = useState(true);

  useEffect(() => {
    socketRef.current = io({
      extraHeaders: {
        Authorization: `Bearer ${auth?.access.token}`,
        ...(xUserId && { 'x-user-id': numberToString(xUserId) }),
      },
    });

    const socket = socketRef.current;

    socket.on('connect', () => {
      setConnecting(false);
    });

    socket.on('connect_error', (error) => {
      console.log(error);
      setConnecting(false);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  if (connecting) {
    return (
      <div className="h-full flex align-center justify-center flex-1">
        <Spin />
      </div>
    );
  }

  return <SocketContext.Provider value={{ socket: socketRef.current }}>{children}</SocketContext.Provider>;
};
